import React from "react";
import Dashboard from "../../Components/Dashboard/Dashboard";


const PageDashboard: React.FC = () => {
  return (
    <Dashboard/>
  );
};

export default PageDashboard;
